export default __webpack_public_path__ + "static/probeam-728aa670bd98ff0bc57b40ffb94f61dc.png";